import React, { useState, useEffect } from 'react';
import CloseButton from '../../../../sharecomponents/CloseButton';
import Post from '../../../../../utils/Post';
import VainillaDialog from '../../../../sharecomponents/vanilladialog';
import Verifiers from '../../../../../utils/Verifiers.jsx';

const AgregarProductoFumigacion = (p) => {
    const update = p.data ? true : false;
    const [data, setdata] = useState({
        id: p.data?.id,
        nombre: p.data?.nombre ?? '',
        dosis: p.data?.dosis ?? 0,
        um_dosis: p.data?.um_dosis ?? '',
        ingrediente_activo: p.data?.ingrediente_activo ?? '',
        clasificacion: p.data?.clasificacion ?? '',
        mecanismo_accion: p.data?.mecanismo_accion ?? '',
        categoria_toxicologica: p.data?.categoria_toxicologica ?? '',
        costo_dosis: p.data?.costo_dosis ?? 0,
        horas_r_e: p.data?.horas_r_e ?? ''
    });
    const close = p.close ?? (() => { });
    const title = p.title ?? '';
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    useEffect(() => {

    }, []);

    const APISend = async (action, data) => {
        let resp = await Post(`/mipe/productos/${action}`, { ...data }, 'POST', setloader);
        if (!resp.estatus) {
            Verifiers.activeDialog(setdialog, resp.msj, 'Error', 'error');
            return;
        }
        close(resp.data);
    }

    const add = () => {
        if (data.nombre.trim() === '') {
            Verifiers.activeDialog(setdialog, 'El nombre no puede estar vacío', 'Error', 'error');
            return;
        }
        if (!update) APISend('add', {
            nombre: data.nombre,
            dosis: data.dosis,
            um_dosis: data.um_dosis,
            ingrediente_activo: data.ingrediente_activo,
            clasificacion: data.clasificacion,
            mecanismo_accion: data.mecanismo_accion,
            categoria_toxicologica: data.categoria_toxicologica,
            costo_dosis: data.costo_dosis,
            horas_r_e: data.horas_r_e
        });
        else if (update) APISend('update', {
            id: data.id,
            nombre: data.nombre,
            dosis: data.dosis,
            um_dosis: data.um_dosis,
            ingrediente_activo: data.ingrediente_activo,
            clasificacion: data.clasificacion,
            mecanismo_accion: data.mecanismo_accion,
            categoria_toxicologica: data.categoria_toxicologica,
            costo_dosis: data.costo_dosis,
            horas_r_e: data.horas_r_e
        });
    }

    const deleteReg = () => APISend('delete', { id: data.id });

    const confirmDelete = () => setdialog({
        tipo: "error",
        show: true,
        title: "CONFIRME PARA CONTINUAR",
        body: "¿Realmente desea eliminar este registro? Esta acción no se puede deshacer.",
        respYes: "Si, eliminar",
        respNot: "Cancelar",
        funct: (resp) => { if (resp) deleteReg(); setdialog({ show: false }) },
        size: 'm'
    })

    const change = (e) => setdata({ ...data, [e.target.name]: e.target.value })

    return (
        <div className='vw-100 vh-100 blur-l dosis p-1' style={{ zIndex: 999, top: 0, left: 0, position: "fixed" }}>
            <CloseButton close={() => close(false)} />
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='col-auto p-1 ps-3 pe-3 round-xxl bg-white shadow h4 text-300'>{title} <span className='text-m text-bold ms-2'>{update ? 'Actualizar' : 'Nuevo'}</span> </div>
                <div className='w-100 m-0 p-0' />
                <div className='bw-900 bg-white shadow-multi round-m p-2 mt-2 mb-5'>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        <div className='bw-400 mt-2'>
                            <label className='text-bold text-s w-100 ps-3'>Nombre</label>
                            <input className='form-control form-control-sm shadow round-m'
                                name='nombre' type='text' value={data.nombre} onChange={change} />
                        </div>
                        <div className='bw-400 mt-2'>
                            <label className='text-bold text-s w-100 ps-3'>Ingrediente activo</label>
                            <input className='form-control form-control-sm shadow round-m'
                                name='ingrediente_activo' type='text' value={data.ingrediente_activo} onChange={change} />
                        </div>
                        <div className='bw-400 mt-2'>
                            <label className='text-bold text-s w-100 ps-3'>Dosis</label>
                            <input className='form-control form-control-sm shadow round-m'
                                name='dosis' type='number' value={data.dosis} onChange={change} />
                        </div>
                        <div className='bw-400 mt-2'>
                            <label className='text-bold text-s w-100 ps-3'>UM dosis</label>
                            <input className='form-control form-control-sm shadow round-m'
                                name='um_dosis' type='text' value={data.um_dosis} onChange={change} />
                        </div>
                        <div className='bw-400 mt-2'>
                            <label className='text-bold text-s w-100 ps-3'>Categoria toxicologica</label>
                            <input className='form-control form-control-sm shadow round-m'
                                name='categoria_toxicologica' type='text' value={data.categoria_toxicologica} onChange={change} />
                        </div>
                        <div className='bw-400 mt-2'>
                            <label className='text-bold text-s w-100 ps-3'>Clasificación</label>
                            <input className='form-control form-control-sm shadow round-m'
                                name='clasificacion' type='text' value={data.clasificacion} onChange={change} />
                        </div>
                        <div className='bw-400 mt-2'>
                            <label className='text-bold text-s w-100 ps-3'>Mecanismo de acción</label>
                            <input className='form-control form-control-sm shadow round-m'
                                name='mecanismo_accion' type='text' value={data.mecanismo_accion} onChange={change} />
                        </div>
                        <div className='bw-400 mt-2'>
                            <label className='text-bold text-s w-100 ps-3'>Costo dosis</label>
                            <input className='form-control form-control-sm shadow round-m'
                                name='costo_dosis' type='number' value={data.costo_dosis} onChange={change} />
                        </div>
                        <div className='bw-400 mt-2'>
                            <label className='text-bold text-s w-100 ps-3'>Horas reentrada etiqueta</label>
                            <input className='form-control form-control-sm shadow round-m'
                                name='horas_r_e' type='text' value={data.horas_r_e} onChange={change} />
                        </div>
                        <div className='w-100' />
                        {
                            update && <div className='bw-200 mt-3 mb-4'>
                                <button className='btn btn-danger btn-sm w-100 shadow round-xxl text-bold' onClick={confirmDelete}>Eliminar</button>
                            </div>
                        }
                        <div className='bw-350 mt-3 mb-4'>
                            <button className='btn btn-warning btn-sm w-100 shadow round-xxl text-bold' onClick={add}>{update ? 'Actualizar' : 'Agregar'}</button>
                        </div>
                    </div>
                </div>
            </div>
            {loader && ldr}
            <VainillaDialog data={dialog} />
        </div>
    )
}

export default AgregarProductoFumigacion;